import "@scss/front/home.scss";

(function() {
    const container = document.querySelector('.ac-slider-home-container');
    if (!container) return;

    const items = container.querySelectorAll('.ac-slider-item');
    const dots = container.querySelectorAll('.ac-slider-dot');
    const prevBtn = container.querySelector('.ac-slider-prev');
    const nextBtn = container.querySelector('.ac-slider-next');

    const delay = parseInt(container.dataset.delay, 10) || 5000;
    let currentSlide = 0;
    let autoplayTimer;

    function showSlide(n) {
        items.forEach(function(item) { item.classList.remove('active'); });
        dots.forEach(function(dot) { dot.classList.remove('active'); });

        items[n].classList.add('active');
        if (dots[n]) dots[n].classList.add('active');
        currentSlide = n;

        resetAutoplay();
    }

    function nextSlide() {
        showSlide((currentSlide + 1) % items.length);
    }

    function prevSlide() {
        showSlide((currentSlide - 1 + items.length) % items.length);
    }

    function resetAutoplay() {
        clearTimeout(autoplayTimer);
        if (items.length > 1) {
            autoplayTimer = setTimeout(nextSlide, delay);
        }
    }

    if (prevBtn) prevBtn.addEventListener('click', prevSlide);
    if (nextBtn) nextBtn.addEventListener('click', nextSlide);

    dots.forEach(function(dot, index) {
        dot.addEventListener('click', function() { showSlide(index); });
    });

    if (items.length > 0) {
        showSlide(0);
    }

    document.addEventListener('visibilitychange', function() {
        if (document.hidden) {
            clearTimeout(autoplayTimer);
        } else {
            resetAutoplay();
        }
    });
})();